import React from "react";
import { Redirect } from "react-router-dom";

import LoginForm from "components/Auth/Login/LoginForm";
import { useSelector } from "react-redux";
import { AppRouteURI } from "router/RoleBasedAccess";

const LoginContainer = () => {
  const { loggedIn } = useSelector((state) => state.auth);
  return loggedIn ? <Redirect to={AppRouteURI.HOME} /> : <LoginForm />;
};

export default LoginContainer;
